'use client';

import { useEffect, useState } from 'react';
import { SITE } from '@/app/constants';
import { apiGetArtistProgramInviteCode, apiGetPartnerBonusCode } from '../apis';

interface CreatorCodesState {
  inviteCode: string;
  partnerCode: string;
  inviteReady: boolean;
  partnerReady: boolean;
}

/**
 * Load invite / partner codes for profile creator-center cards without creating them.
 * Empty string after ready means the user has not claimed yet.
 */
export function useCreatorCodes(approved: boolean): CreatorCodesState {
  const [inviteCode, setInviteCode] = useState('');
  const [partnerCode, setPartnerCode] = useState('');
  const [inviteReady, setInviteReady] = useState(!approved);
  const [partnerReady, setPartnerReady] = useState(SITE !== 'china' || !approved);

  useEffect(() => {
    if (!approved) {
      setInviteCode('');
      setInviteReady(true);
      return;
    }

    let cancelled = false;
    setInviteReady(false);

    void apiGetArtistProgramInviteCode()
      .then((code) => {
        if (!cancelled) setInviteCode(code);
      })
      .finally(() => {
        if (!cancelled) setInviteReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, [approved]);

  useEffect(() => {
    if (SITE !== 'china' || !approved) {
      setPartnerCode('');
      setPartnerReady(true);
      return;
    }

    let cancelled = false;
    setPartnerReady(false);

    void apiGetPartnerBonusCode()
      .then((code) => {
        if (!cancelled) setPartnerCode(code);
      })
      .finally(() => {
        if (!cancelled) setPartnerReady(true);
      });

    return () => {
      cancelled = true;
    };
  }, [approved]);

  return { inviteCode, partnerCode, inviteReady, partnerReady };
}
